import { RagChatToggleService } from '../../service/rag-chat-toggle.service';
import { CreationDropdownNodesService } from './creation-dropdown-nodes.service';
import { Injectable } from '@angular/core';
import {
  ConfigService,
  CustomGlobalNodesService,
  LuigiNode,
  NodeContext,
  NodeUtilsService,
} from '@openmfp/portal-ui-lib';
import { featureToggles } from 'src/app/models/feature-toggles';

@Injectable({ providedIn: 'root' })
export class DxpCustomGlobalNodesService implements CustomGlobalNodesService {
  constructor(
    private creationDropdownNodesService: CreationDropdownNodesService,
    private nodeUtilsService: NodeUtilsService,
    private ragChatToggleService: RagChatToggleService,
    private configService: ConfigService,
  ) {}

  async getCustomGlobalNodes(): Promise<LuigiNode[]> {
    return [
      this.createHelpCenterNode(),
      this.createErrorNode(),
      this.createNotificationAnchorNode(),
      this.createJouleNode(),
      this.createRagChatNode(),
      ...(await this.creationDropdownNodesService.buildCreationDropdownNodes()),
    ];
  }

  private createHelpCenterNode(): LuigiNode {
    return {
      testId: 'dxp-help-center-global-button',
      icon: 'sys-help',
      entityType: 'global.topnav',
      viewUrl: '/help',
      pathSegment: 'help',
      navigationContext: 'help-center',
      label: 'Help Center',
      context: {} as NodeContext,
      openNodeInModal: {
        size: 'fullscreen',
      },
      onNodeActivation: this.nodeUtilsService.retrieveGlobalHelpContext(),
    };
  }

  private createErrorNode(): LuigiNode {
    return {
      pathSegment: 'error',
      label: 'Content not found',
      hideFromNav: true,
      context: {} as NodeContext,
      children: [
        {
          pathSegment: ':id',
          hideSideNav: true,
          viewUrl: '/error-handling#:id',
          context: { id: ':id' } as any,
          loadingIndicator: { enabled: false },
          showBreadcrumbs: false,
        },
      ],
    };
  }

  private createNotificationAnchorNode(): LuigiNode {
    return {
      testId: 'dxp-notification-anchor',
      icon: '',
      entityType: 'global.topnav',
      viewUrl: '/home',
      pathSegment: 'home',
      context: {} as NodeContext,
      navigationContext: '',
      openNodeInModal: {
        size: 'fullscreen',
      },
    };
  }

  private createJouleNode(): LuigiNode {
    // we need this button to call window.sap.das.webclient.toggle() to open Joule
    // Documentation: https://github.tools.sap/DAS/webclient/tree/main/doc#toggle
    return {
      testId: 'dxp-joule-global-button',
      icon: 'da-2',
      entityType: 'global.topnav',
      label: 'Joule',
      visibleForFeatureToggles: [featureToggles.ENABLE_JOULE],
      pathSegment: 'joule',
      viewUrl: '/joule',
      navigationContext: 'joule',
      context: {} as NodeContext,
      onNodeActivation: () => {
        ((window as any).sap as any).das.webclient.toggle();
        return false;
      },
    };
  }

  private createRagChatNode(): LuigiNode {
    return {
      testId: 'dxp-rag-chat-global-button',
      icon: 'ai',
      entityType: 'global.topnav',
      label: 'Docs Chat',
      visibleForFeatureToggles: [featureToggles.ENABLE_RAG_CHAT],
      pathSegment: 'rag-chat',
      viewUrl: '/rag-chat',
      navigationContext: 'rag-chat',
      context: {} as NodeContext,
      onNodeActivation: () => {
        this.ragChatToggleService.toggle();
        return false;
      },
    };
  }
}
